import React from "react";
import axios from "axios";
import { useEffect, useState } from "react";

const gmacDicts = {
    1: "TAG01",
    2: "TAG02",
    3: "TAG03",
    107: "TAG0107",
    "107Pro": "TAG0107Pro",
    117: "TAG0117",
};

const MqttList = () => {
    const id = window.localStorage.getItem("id");
    const token = window.localStorage.getItem("token");
    const [info, setinfo] = useState([]);
    const [url, setUrl] = useState("");
    const GetGmacs = async () => {
        try {
            const response = await axios.get(
                "http://tagard.in:8005/influx/mqtt/" + String(id) + "/"
            );
            setinfo(response.data["mqtts"]);
            console.log(response.data["mqtts"][0]["shareurl"]);
            setUrl(response.data["mqtts"][0]["shareurl"]);
        } catch (error) {
            console.error("Error fetching info:", error);
        }
    };

    useEffect(() => {
        GetGmacs();
    }, []);

    return (
        <>
            <div>GmacList</div>
            <table className="w-50">
                <tr>
                    <th>Gmac Name</th>
                    <th>Gmac Type</th>
                </tr>
                {info.map((item) => {
                    return <GmacList {...item} />;
                })}
            </table>
        </>
    );
};

const GmacList = ({ mqtt, gmacType, shareurl }) => {
    return (
        <>
            <tr>
                <td>{mqtt}</td>
                <button>Alias</button>
                <td>{gmacDicts[gmacType]}</td>
            </tr>
            <iframe
                src={shareurl}
                width="1350"
                height="600"
                // frameBorder="0"
            ></iframe>
        </>
    );
};
export default MqttList;
